import { createContext, useContext, useEffect, useState } from "react";
import { useHomeTeam } from "./useHomeTeam";

type ThemeContextType = {
  colors: {
    primary: string;
    secondary: string;
  };
};

const DEFAULT_THEME = {
  colors: {
    primary: "145.44 63.2% 49.02%",
    secondary: "143.08 48.75% 31.37%",
  },
};

const ThemeContext = createContext<ThemeContextType>(DEFAULT_THEME);

export function ThemeProvider({
  children,
  wrapper,
}: {
  children: React.ReactNode;
  wrapper?: React.Ref<HTMLDivElement>;
}) {
  const { code } = useHomeTeam();

  const [theme, setTheme] = useState<ThemeContextType>(DEFAULT_THEME);

  useEffect(() => {
    if (code === "HNS" || code === "DAD") {
      setTheme({
        colors: {
          primary: "340.71 55.26% 70.2%",
          secondary: "340.71 55.26% 70.2%",
        },
      });
    } else if (code === "DSE") {
      setTheme({
        colors: {
          primary: "210 50% 60%",
          secondary: "210 50% 40%",
        },
      });
    } else if (code === "CSP") {
      setTheme({
        colors: {
          primary: "12 65% 39%",
          secondary: "12 65% 20%",
        },
      });
    }
  }, [code]);

  useEffect(() => {
    if (theme.colors) {
      Object.entries(theme.colors).forEach(([key, value]) => {
        if (wrapper && "current" in wrapper && wrapper.current) {
          wrapper.current.style.setProperty(`--heroui-${key}`, value);
        }
      });

      if (theme.colors.primary) {
        const metaThemeColor = document.querySelector(
          'meta[name="theme-color"]'
        );
        if (metaThemeColor) {
          metaThemeColor.setAttribute(
            "content",
            `hsl(${theme.colors.secondary})`
          );
        }
      }
    }
  }, [theme, wrapper]);

  return (
    <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
